import { checkParams, zeroUnit, soFarDate, timePeriod } from '../../utils'
import { formatTime, formatDate, formatDatetime } from '../../filter'

export default function() {
	const res = this.checkParams()
	if (!res) {
		return
	}
	const { order, injured, setting } = this
	if (this.isMotion || this.isNewMotion || this.isResurvey) {
		return false
	}

	let arr = []

	const hasWork = !(injured.work && ['0', ''].includes(injured.work.hasWork))

	if (hasWork) {
		let list = [{}]
		if (injured.work && injured.work.workInfoList.length) {
			list = injured.work.workInfoList
		}

		const isTargetInsurance =
			(this.isLiabilityInsurance || this.isAccidentInsurance) && !this.isPAIC
		for (const item of list) {
			let workInfoArr = []
			let isPAIC = this.isPAIC && this.isFirstVisit
			if (isPAIC) {
				workInfoArr.push(
					{
						label: '所属行业',
						value: item.industryName,
					},
					{
						label: '职业类别',
						value:
							item.vocationName && item.secondVocationName
								? [item.vocationName, item.secondVocationName].join(' - ')
								: '',
					}
				)
			}
			workInfoArr.push(
				{
					label: '工作单位',
					value: item.companyName,
				},
				{
					label: '工作地址',
					value: item.workAddress && item.workAddress + item.workPlace,
				},
				{
					label: '工作起止日期',
					value: timePeriod(item.beginDate, item.endDate),
				}
			)
			if (this.isPAIC) {
				workInfoArr.push({ label: '岗位名称', value: item.jobName })
			} else {
				if (isTargetInsurance && this.isFirstVisit) {
					workInfoArr.push(
						{
							label: '职业工种',
							value: item.professionDesc,
						},
						{
							label: '职务',
							value: item.jobTitle,
						}
					)
				} else {
					workInfoArr.push({ label: '岗位名称', value: item.jobName })
				}
			}

			workInfoArr = workInfoArr.concat([
				{
					label: '工资发放形式',
					value: setting.wageTypeMap[item.wageType],
				},
				{
					label: '自述工资/收入',
					value: zeroUnit(item.wage, '元/月'),
				},
			])
			if (isPAIC) {
				workInfoArr.push({
					label: '是否签订劳动合同',
					value: setting.yesNoMap[item.contract],
				})
			} else {
				workInfoArr.push({
					label: '是否缴纳社保',
					value: setting.yesNoMap[item.socialSecurity],
				})
			}
			if (isTargetInsurance && this.isFirstVisit) {
				workInfoArr.push(
					{
						label: '证明人姓名',
						value: item.certifierName,
					},
					{
						label: '证明人关系',
						value: item.certifierRelation,
					},
					{
						label: '证明人电话',
						value: item.certifierMobile,
					},
					{
						label: '有无对应资格证件',
						value:
							item.qualification === '1'
								? item.qualificationDesc
								: setting.haveNoneMap[item.qualification],
					}
				)
			}
			workInfoArr.push({
				label: '备注（非必填）',
				value: item.remark,
			})
			arr.push(workInfoArr)
		}
	}

	const obj = {
		title: '伤者至少超过一年的完整工作经历',
		children: arr,
		show: {
			hasWork,
		},
	}

	return obj
}
